import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';
import { registrarEvento } from './analyticsService';

// Capa de datos de las ÓRDENES DE SERVICIO. Multi-tenant por negocio_id + RLS.

export async function obtenerOrdenes() {
  const { data, error } = await supabase
    .from('ordenes_servicio')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('creado_en', { ascending: false });
  if (error) throw error;
  return data || [];
}

// Correlativo OS-#### por negocio (los números van con ceros para ordenar bien).
async function generarNumeroOrden() {
  const { data } = await supabase
    .from('ordenes_servicio')
    .select('numero')
    .eq('negocio_id', getNegocioId())
    .like('numero', 'OS-%')
    .order('numero', { ascending: false })
    .limit(1);
  const ultimo = data && data[0]?.numero ? parseInt(String(data[0].numero).split('-')[1], 10) : 0;
  return `OS-${String((ultimo || 0) + 1).padStart(4, '0')}`;
}

export async function crearOrden(datos) {
  const numero = await generarNumeroOrden();
  const { data, error } = await supabase
    .from('ordenes_servicio')
    .insert([{ ...datos, negocio_id: getNegocioId(), numero }])
    .select()
    .single();
  if (error) throw error;
  registrarEvento('orden_creada', { servicio: datos.servicio_nombre || null });
  return data;
}

export async function actualizarOrden(id, datos) {
  const { error } = await supabase
    .from('ordenes_servicio')
    .update({ ...datos, actualizado_en: new Date().toISOString() })
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}

export async function cambiarEstadoOrden(id, estado) {
  const { error } = await supabase
    .from('ordenes_servicio')
    .update({ estado, actualizado_en: new Date().toISOString() })
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}

export async function eliminarOrden(id) {
  const { data, error } = await supabase
    .from('ordenes_servicio').delete()
    .eq('id', id).eq('negocio_id', getNegocioId())
    .select('evidencias');
  if (error) throw error;
  // Borra también las fotos de evidencia del Storage (best-effort).
  const marcador = '/object/public/productos-fotos/';
  const rutas = (data?.[0]?.evidencias || [])
    .filter((url) => typeof url === 'string' && url.includes(marcador))
    .map((url) => decodeURIComponent(url.split(marcador)[1]));
  if (rutas.length) await supabase.storage.from('productos-fotos').remove(rutas).catch(() => {});
}
